import { otherColors } from '@klv/shared/styles/colors';

const klaviyoStatusIndicator = {
  fallback: {
    indicatorColor: otherColors.gray70,
  },
  none: {
    indicatorColor: 'rgba(47, 203, 102, 1)',
  },
  minor:{
    indicatorColor: 'rgba(244, 204, 71, 1)',
  },
  major: {
    indicatorColor: 'rgba(230, 125, 35, 1)',
  },
  critical: {
    indicatorColor: 'rgba(232, 81, 66, 1)',
  },
  maintenance: {
    indicatorColor: 'rgba(53, 152, 218, 1)',
  },
};

export default klaviyoStatusIndicator;
